import React, { useState } from 'react';
import styled from '@emotion/styled';
import { Icon as BaseIcon } from 'components/Icon/Icon';
import facebookIcon from 'assets/facebook.svg';
import linkedInIcon from 'assets/linkedin.svg';
import facebookIconColored from 'assets/facebookColored.svg';
import twitterIconColored from 'assets/twitterColored.svg';
import linkedInIconColored from 'assets/linkedInColored.svg';
import twitterIcon from 'assets/twitter.svg';
import { Link } from 'components/Link/Link';

const Outer = styled.div`
  display: grid;
  justify-content: center;
  grid-template-columns: 20px 20px 20px;
  grid-column-gap: 20px;
`;

const Icon = styled(BaseIcon)`
  display: inline-block;
  height: 20px;
  width: 20px;
`;

export const ArticleHeroSocialIcons = ({
  className,
}: {
  className?: string;
}) => {
  const [facebook, setFacebookIcon] = useState(facebookIcon);
  const [twitter, setTwitterIcon] = useState(twitterIcon);
  const [linkedIn, setLinkedInIcon] = useState(linkedInIcon);

  const linkProps = (
    setIcon: React.Dispatch<any>,
    icon: any,
    coloredIcon: any,
  ) => ({
    onMouseEnter: () => setIcon(coloredIcon),
    onMouseLeave: () => setIcon(icon),
  });

  return (
    <Outer className={className}>
      <Link
        {...linkProps(setFacebookIcon, facebookIcon, facebookIconColored)}
        href="https://facebook.com/ZapierApp/"
      >
        <Icon svg={facebook} />
      </Link>
      <Link
        {...linkProps(setTwitterIcon, twitterIcon, twitterIconColored)}
        href="https://twitter.com/zapier"
      >
        <Icon svg={twitter} />
      </Link>
      <Link
        {...linkProps(setLinkedInIcon, linkedInIcon, linkedInIconColored)}
        href="https://linkedin.com/company/zapier"
      >
        <Icon svg={linkedIn} />
      </Link>
    </Outer>
  );
};
